import Wizard from '@/components/wizard/Wizard.vue';

/**
 * Mixin kreatora
 */
export function wizardMixin(moduleName) {
  return {
    components: {
      Wizard
    },
    props: {
      // Tytuł strony
      title: { type: String, required: true },
      // Kroki
      steps: { type: Array, required: true }
    },
    computed: {
      edit() {
        return this.$route.params[moduleName + 'Id'];
      },
      currentStep() {
        return this.steps.findIndex(step => step.name === this.$route.name);
      }
    },
    methods: {
      // @vuese
      // Zmienia zakładkę
      changeStep(index) {
        if (this.edit) {
          this.$router.push({ name: this.steps[index].name });
        }
      },
      // @vuese
      // Przenosi do następnego kroku
      nextStep(id) {
        const nextStep = this.steps[this.currentStep + 1];
        if (nextStep) {
          this.$router.push({ name: nextStep.name, params: { [moduleName + 'Id']: id } });
        }
      },

      // @vuese
      // Przenosi do poprzedniego kroku
      previousStep(id) {
        const previousStep = this.steps[this.currentStep - 1];
        if (previousStep) {
          this.$router.push({ name: previousStep.name, params: { [moduleName + 'Id']: id } });
        }
      }
    }
  };
}
